import { Injectable } from "@angular/core";
import { IID_RISORSE_VERIFICA } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { ActionService } from "../action/action.service";
import { CrudService } from "../crudService";
import { ProjectEntityStoreStrategy } from "../updateStoreStrategies";
import { RisorseVerificaQuery } from "./risorseVerifica.query";
import { RisorseVerificaStore } from "./risorseVerifica.store";
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.IID_RISORSE_VERIFICA)
export class RisorseVerificaService extends CrudService<IID_RISORSE_VERIFICA, RisorseVerificaStore, RisorseVerificaQuery> {
  constructor(
    protected store: RisorseVerificaStore,
    public query: RisorseVerificaQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy
  ) {
    super(Topics.IID_RISORSE_VERIFICA, store, query, actionService, updateStrategy);
  }
}
